import { toast } from 'react-toastify';
import { API_SYSTEM_ADMIN_LICENSEE, API_SYSTEM_ADMIN_LICENSEES, API_SYSTEM_ADMIN_LICENSEE_DELETE_CHECKING, POPUP_TYPE } from '../../../../constants';

import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';
import {
     setIsWaiting,
     setIsLoading,
     setRemoveLoading,
     setShowRemovePopup,
     setShowPopupDetail,
     setShowRelatedObjectWarningPopup,
     setShowPopup,
} from '../../../../actions/general';
import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';

export const ADD_ADMIN_LICENSEE = 'addAdminLicensee';
export const ADD_ADMIN_LICENSEES = 'addAdminLicensees';
export const UPDATE_ADMIN_LICENSEE = 'updateAdminLicensee';
export const DELETE_ADMIN_LICENSEE = 'deleteAdminLicensee';

const addSystemAdminLicensee = (licensee) => {
     return {
          type: ADD_ADMIN_LICENSEE,
          payload: licensee,
     };
};

const addSystemAdminLicensees = (licensees) => {
     return {
          type: ADD_ADMIN_LICENSEES,
          payload: licensees,
     };
};

const updateSystemAdminLicensee = (licensee) => {
     return {
          type: UPDATE_ADMIN_LICENSEE,
          payload: licensee,
     };
};

const deleteSystemAdminLicensee = (licenseeId) => {
     return {
          type: DELETE_ADMIN_LICENSEE,
          payload: licenseeId,
     };
};

export const addLicenseeToDataAddProduct = (licensee) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newLicensee = {
               id: licensee.id,
               name: licensee.name,
               designationElement: licensee.designationElement,
               testMode: licensee.testMode,
          };
          dataAddProduct.licensees.push(newLicensee);
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const updateLicenseeToDataAddProduct = (licensee) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;
     if (dataAddProduct !== null) {
          const newDataLicensees = dataAddProduct.licensees.map((licenseeItem) => {
               const newLicensee = {
                    id: licensee.id,
                    name: licensee.name,
                    designationElement: licensee.designationElement,
                    testMode: licensee.testMode,
               };
               if (licenseeItem.id === newLicensee.id) {
                    return { ...licenseeItem, ...newLicensee };
               }
               return licenseeItem;
          });

          dataAddProduct.licensees = newDataLicensees;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const deleteLicenseeFromDataAddProduct = (id) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newDataLicensees = dataAddProduct.licensees.filter((licenseeItem) => licenseeItem.id !== id);
          dataAddProduct.licensees = newDataLicensees;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const fetchSystemAdminLicenseesRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));

     return callApi(API_SYSTEM_ADMIN_LICENSEES, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addSystemAdminLicensees(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addSystemAdminLicenseeRequest = (licensee) => (dispatch) => {
     dispatch(setIsWaiting(true));

     return callApi(API_SYSTEM_ADMIN_LICENSEES, 'POST', licensee)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newLicensee = response.data;
               dispatch(addSystemAdminLicensee(newLicensee));
               dispatch(addLicenseeToDataAddProduct(newLicensee));
               dispatch(setShowPopup());
               toast.success('Created Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSystemAdminLicenseeRequest = (licenseeId, newLicensee) => (dispatch) => {
     return callApi(API_SYSTEM_ADMIN_LICENSEE.replace(':id', licenseeId), 'PUT', newLicensee)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newLicensee = response.data;
               dispatch(updateSystemAdminLicensee(newLicensee));
               dispatch(updateLicenseeToDataAddProduct(newLicensee));
               dispatch(setShowPopupDetail(null));
               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const deleteSystemAdminLicenseeRequest = (id) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     return callApi(API_SYSTEM_ADMIN_LICENSEE.replace(':id', id), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    return;
               }

               dispatch(deleteSystemAdminLicensee(id));
               dispatch(deleteLicenseeFromDataAddProduct(id));
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const checkCanDeleteLicenseeRequest = (id) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_LICENSEE_DELETE_CHECKING.replace(':id', id), 'GET').then((response) => {
          if (response.status === 200) {
               if (response.data.canDelete) {
                    dispatch(setShowRemovePopup(id));
               }
          } else {
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRemovePopup(null));
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
               } else {
                    toastError(response);
               }
          }
     });
};

export const checkUpdateLicenseeRequest = (nextDispatch) => (dispatch) => {
     const { isEditing, checkedValue, setFieldValue, setStatusLoading, licenseeId } = nextDispatch;
     //check status for delete only on edit page
     if (isEditing === undefined) {
          setFieldValue('status', checkedValue);
          return;
     }
     //check status for delete only on status = true
     if (checkedValue) {
          setFieldValue('status', checkedValue);
          return;
     }

     setStatusLoading(true);

     return callApi(API_SYSTEM_ADMIN_LICENSEE_DELETE_CHECKING.replace(':id', licenseeId), 'GET')
          .then((response) => {
               if (response.status === 200 && response.data.canDelete) {
                    setFieldValue('status', checkedValue);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    setFieldValue('status', !checkedValue);
                    return;
               }

               toastError(response);
          })
          .finally(() => setStatusLoading(false));
};
